module.exports = __webpack_public_path__ + "static/mockup_small-8b62320bed8974b3b15b430b7fdd81b9.png";